import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const ClearIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 3L21 20M21 3L12.5 11.5L4 20" stroke="currentColor" strokeWidth={1.5}/>
    </svg>
)
const ClearIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon fontSize="small" {...props}>
        {ClearIconSvg}
    </SvgIcon>
)
export default ClearIcon
